<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      transition="dialog-top-transition"
      max-width="550px"
    >
      <v-card>
        <div class="container-comfirm">
          <div class="card-title">
            <h3>ต้องการลบรายการบันทึก ?</h3>
          </div>
          <div class="d-flex justify-content-between">
            <v-btn class="btn-checklist" @click="$emit('close')">กลับ</v-btn>
            <v-btn class="btn-submit" @click="$emit('save')">บันทึก</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    id: String
  }
}
</script>

<style lang="scss" scoped>
.container-comfirm {
  justify-content: center;
  margin: 30px 25px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.card-title {
  margin: 20px 0px;
}
</style>
